import AOS from "aos"
import "aos/dist/aos.css"

const hamburger = document.querySelector(".hamburger")
const navItems = document.querySelector(".nav-items")
const navLink = document.querySelectorAll(".nav-item")

hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("active")
    navItems.classList.toggle("active")
})

navLink.forEach(item =>
    item.addEventListener("click", event => {
        if (!item.classList.contains("dropdown")) {
            hamburger.classList.remove("active")
            navItems.classList.remove("active")
        }
    })
)

const dropdowns = document.querySelectorAll(".dropdown")

dropdowns.forEach(dropdown => {
    dropdown.addEventListener("click", event => {
        event.stopPropagation()
        dropdown.classList.toggle("show")
    })
})

document.addEventListener("click", () => {
    dropdowns.forEach(dropdown => {
        dropdown.classList.remove("show")
    })
})

window.changeLanguage = function (lang) {
    localStorage.setItem("preferredLang", lang)

    const currentOrigin = window.location.origin
    const path = window.location.pathname

    let fileName = path.replace(/^\/(tr|ar)\//, "").replace(/^\//, "")
    if (!fileName || fileName === "/" || fileName.endsWith("/")) {
        fileName = "index.html"
    }

    const languages = {
        en: "",
        tr: "tr",
        ar: "ar"
    }

    const langPrefix = languages[lang] || ""
    const targetUrl = `${currentOrigin}/${langPrefix ? langPrefix + "/" : ""}${fileName}`

    if (window.location.href !== targetUrl) {
        window.location.href = targetUrl
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const hostname = window.location.hostname
    const path = window.location.pathname

    const isRootPath = path === "/" || path === "/index.html"

    if (hostname.includes("zeron-kilit") && isRootPath) {
        const preferredLang = localStorage.getItem("preferredLang") || "tr"
        const targetPath =
            preferredLang === "tr" ? "/tr/index.html" : preferredLang === "ar" ? "/ar/index.html" : "/index.html"
        const targetUrl = `${window.location.origin}${targetPath}`

        if (window.location.href !== targetUrl) {
            window.location.replace(targetUrl)
        }
    }
})
